import { TenantProvider } from "@/contexts/TenantContext"
import { AcessoAoFinanceiroProvider } from "@/contexts/AcessoAoFinanceiroContext"

/**
 * AppProviders wraps all context providers for the application.
 *
 * BrowserRouter and Toaster are already provided in main.tsx.
 * This component handles app-level context providers only.
 */
interface AppProvidersProps {
  children: React.ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <TenantProvider>
      <AcessoAoFinanceiroProvider>{children}</AcessoAoFinanceiroProvider>
    </TenantProvider>
  )
}
